import l1 from "../../images/l1.svg";
import l2 from "../../images/l2.svg";
import l3 from "../../images/l3.svg";
import l4 from "../../images/l4.svg";
import r1 from "../../images/r1.svg";
import r2 from "../../images/r2.svg";
import r3 from "../../images/r3.svg";
import r4 from "../../images/r4.svg";

const leftList = [
  { img: l1, text: "Identify their natural talents and areas of interest", alt: "Talent identification icon" },
  { img: l2, text: "Explore suitable career paths based on their abilities", alt: "Career exploration icon" },
  { img: l3, text: "Make confident and informed decisions about higher education", alt: "Higher education decision icon" },
  { img: l4, text: "Avoid career mismatches and unnecessary academic pressure", alt: "Avoid pressure icon" },
];

const rightList = [
  { img: r1, text: "Choose the right subjects in higher secondary education", alt: "Subject choice icon" },
  { img: r2, text: "Align their studies with future career aspirations", alt: "Career alignment icon" },
  { img: r3, text: "Develop key skills required for their dream profession", alt: "Skill development icon" },
  { img: r4, text: "Gain a competitive edge in university admissions and scholarships", alt: "University advantage icon" },
];

const Why = () => {
  return (
    <section id="why">
      <div className="why-card why-container">
        <h4>Why is <b>Skill Assessment</b> Important?</h4>
        <p>
          We are dedicated to providing the best career guidance and skill assessment services.
          Our team of experts is here to help you navigate your career path with confidence.
        </p>
        <ul>
          {leftList.map((item, index) => (
            <li key={`left-${index}`}>
              <img src={item.img} alt={item.alt} />
              {item.text}
            </li>
          ))}
        </ul>
      </div>

      <div className="why-card why-early">
        <h4>Why Should Skill Assessment Be <b>Taken Early?</b></h4>
        <p>
          The earlier students discover their skills and interests, the better they can plan their academic journey.
          Taking a skill assessment in school (from Class 8 onwards) enables students to:
        </p>
        <ul>
          {rightList.map((item, index) => (
            <li key={`right-${index}`}>
              <img src={item.img} alt={item.alt} />
              {item.text}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Why;
